import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'show-apitoken-dialog',
  templateUrl: './show-apitoken-dialog.component.html',
  styleUrls: ['./show-apitoken-dialog.component.scss']
})
export class ShowApitokenDialogComponent implements OnInit {

  tokenForm!: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    public _dialogRef: MatDialogRef<ShowApitokenDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, // string: das generierte Api Token
    public translate: TranslateService,
    private notificationService: NotificationService,
    private tenantService: TenantService,
    private clipboard: Clipboard
  ) { }

  ngOnInit() {
    this.createTokenForm();
  }
  createTokenForm() {
    this.tokenForm = this.formBuilder.group({
      apiToken:[this.data],
      //apiToken:["walter"],
    });
  }
  cancel(){
    this._dialogRef.close(false);
  }
  copy(){
    this.clipboard.copy(this.data);
    this.notificationService.info("", "Api Token wurde in die Zwischenablage kopiert!");
    this._dialogRef.close(true);
  }
}
